module.exports = __webpack_public_path__ + "img/bgb-ib.bcf6440c.png";